import React, { useEffect, useMemo, useRef, useState } from "react";
import useEstadoSalvamento from "../Utils/useEstadoSalvamento";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";
import RestoreIcon from "@mui/icons-material/Restore";
import { confirmarSistema } from "../Components/PopupSistema/PopupSistema";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { addDoc, collection, doc, getDocs, query, writeBatch } from "firebase/firestore";
import Navbar from "../Components/Navbar/navbar";
import HistoricoCadastro from "../Components/HistoricoCadastro/HistoricoCadastro";
import { db } from "../Config/firebase";
import { gerarSequencial, obterMaiorSequencial } from "../Utils/sequencial";
import { aplicarTenant, getUsuarioAtualComTenant, tenantWhere , consultaTenantAtual, aplicarTenantAtual} from "../Utils/tenant";
import RelatorioCaracterizacaoPrint from "./relatoriocaracterizacaoGraudoPrint";
import RelatorioCaracterizacaoMiudoPrint from "./relatoriocaracterizacaoMiudoPrint";
import { useHistory, useLocation } from "react-router-dom";
import {
  ENSAIOS_CARACTERIZACAO,
  labelMaterial,
} from "../CadastroSolicitacaoServicos/solicitacaoServicosModel";
import { atualizarDocumentoComMesclagem } from "../Utils/concorrenciaFirestore";

const peneirasPadrao = [
  "76,2",
  "63,5",
  "50,8",
  "38,1",
  "31,7",
  "25,4",
  "19,0",
  "12,5",
  "9,5",
  "6,3",
  "4,8",
  "2,4",
  "1,2",
  "0,6",
  "0,3",
  "0,15",
  "Fundo",
];

const granulometriaModelo = peneirasPadrao.map((peneira) => ({ peneira }));

const densidadeVazia = {
  materialSss1: "",
  materialSss2: "",
  frascoMaterial1: "",
  frascoMaterial2: "",
  frascoAgua1: "",
  frascoAgua2: "",
  pesoImerso1: "",
  pesoImerso2: "",
  volumeSss1: "",
  volumeSss2: "",
  volumeSeco1: "",
  volumeSeco2: "",
  materialSeco1: "",
  materialSeco2: "",
  densidadeSss1: "",
  densidadeSss2: "",
  densidadeSeco1: "",
  densidadeSeco2: "",
  densidadeMedia: "",
  absorcao1: "",
  absorcao2: "",
};

const massaUnitariaVazia = {
  volume1: "",
  volume2: "",
  recipienteVazio1: "",
  recipienteVazio2: "",
  recipienteAgregado1: "",
  recipienteAgregado2: "",
  massaAgregado1: "",
  massaAgregado2: "",
  massaUnitaria1: "",
  massaUnitaria2: "",
  mediaMassaUnitaria: "",
};

const torroesPulverulentosVazio = {
  torroesAntes: "",
  torroesDepois: "",
  torroesPercentual: "",
  pulverulentosAntes: "",
  pulverulentosDepois: "",
  pulverulentosPercentual: "",
};

const estadoInicial = {
  codigo: "",
  complementoCodigo: "",
  cliente: "",
  obra: "",
  obraId: "",
  fornecedor: "",
  fornecedorId: "",
  codigoFornecedor: "",
  amostra: "",
  tipoAgregado: "graudo",
  localColeta: "",
  procedencia: "",
  dataGranulometria: "",
  operadorGranulometria: "",
  massaInicialA: "",
  massaInicialB: "",
  totalMassaA: "",
  totalMassaB: "",
  diferencaMaxima: "",
  moduloFinura: "",
  tolerancias: "",
  granulometria: granulometriaModelo,
  dataDensidade: "",
  operadorDensidade: "",
  densidade: densidadeVazia,
  dataMassaUnitaria: "",
  operadorMassaUnitaria: "",
  massaUnitaria: massaUnitariaVazia,
  dataTorroesArgila: "",
  dataMateriaisPulverulentos: "",
  torroesPulverulentos: torroesPulverulentosVazio,
};

const peneirasMiudo = ["9,5", "6,3", "4,8", "2,36", "1,18", "0,60", "0,30", "0,15", "Fundo"];

const granulometriaMiudoModelo = peneirasMiudo.map((peneira) => ({ peneira }));

const estadoInicialMiudo = {
  ...estadoInicial,
  tipoAgregado: "miudo",
  massaInicialA: "",
  massaInicialB: "",
  totalMassaA: "",
  totalMassaB: "",
  diferencaMaxima: "",
  moduloFinura: "",
  tolerancias: "",
  granulometria: granulometriaMiudoModelo,
};

function formatarDataBR(dataISO) {
  if (!dataISO) return "-";
  const [ano, mes, dia] = String(dataISO).split("-");
  if (!ano || !mes || !dia) return dataISO;
  return `${dia}/${mes}/${ano}`;
}

function normalizarTexto(valor) {
  return String(valor || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}

function tipoMaterial(material) {
  return [
    material?.IsAgregadoGraudo && "Agregado graúdo",
    material?.IsAgregadoMiudo && "Agregado miúdo",
    material?.IsCimento && "Cimento",
    material?.IsAditivo && "Aditivo",
    material?.IsAdicao && "Adição",
    material?.IsAgua && "Água",
    material?.IsSolos && "Solos",
  ].filter(Boolean).join(", ");
}

function ehAgregadoMiudo(item) {
  const descricao = normalizarTexto(
    `${item?.amostra || ""} ${item?.descricao || ""} ${item?.tipoMaterial || ""}`
  );

  if (/\b(areia|miudo|po de pedra)\b/.test(descricao)) return true;
  if (/\b(brita|graudo|pedrisco)\b/.test(descricao)) return false;
  return normalizarTexto(item?.tipoAgregado) === "miudo";
}

function rotaDetalhesCaracterizacao(item, id) {
  const base = ehAgregadoMiudo(item)
    ? "/app/cadastro-caracterizacao-miudo"
    : "/app/cadastro-caracterizacao";
  return `${base}/${id}`;
}

function calcularProximoCodigo(lista) {
  const numeros = lista
    .map((item) => Number(String(item.codigo || "").match(/\d+/)?.[0]))
    .filter(Number.isFinite);
  const proximo = numeros.length ? Math.max(...numeros) + 1 : lista.length + 1;
  return String(proximo).padStart(3, "0");
}

function separarCodigoCaracterizacao(valor) {
  const [base = "", ...complemento] = String(valor || "").split(".");
  return {
    base,
    complemento: complemento.join("."),
  };
}

function montarCodigoCaracterizacao(base, complemento) {
  const baseNumerica = Number(String(base || "").trim());
  const baseFormatada = String(baseNumerica).padStart(3, "0");
  const complementoNormalizado = String(complemento || "").trim().toUpperCase();
  return complementoNormalizado
    ? `${baseFormatada}.${complementoNormalizado}`
    : baseFormatada;
}

function compararCodigosCaracterizacaoDecrescente(itemA, itemB) {
  const codigoA = separarCodigoCaracterizacao(itemA?.codigo);
  const codigoB = separarCodigoCaracterizacao(itemB?.codigo);
  const baseA = Number(codigoA.base);
  const baseB = Number(codigoB.base);

  if (baseA !== baseB) return baseB - baseA;
  if (codigoA.complemento && !codigoB.complemento) return -1;
  if (!codigoA.complemento && codigoB.complemento) return 1;

  return codigoB.complemento.localeCompare(codigoA.complemento, "pt-BR", {
    numeric: true,
    sensitivity: "base",
  });
}

export default function CadastroCaracterizacao() {
  const { salvandoCadastro, executarSalvamento } = useEstadoSalvamento();
  const history = useHistory();
  const location = useLocation();
  const cadastroUrlProcessadoRef = useRef(false);
  const [caracterizacoes, setCaracterizacoes] = useState([]);
  const [materiais, setMateriais] = useState([]);
  const [obras, setObras] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState(
    () => location.state?.filtroCaracterizacao || ""
  );
  const [filtroStatus, setFiltroStatus] = useState(
    () => location.state?.filtroStatusCaracterizacao || "ativos"
  );
  const [itemAtualizandoStatusId, setItemAtualizandoStatusId] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [modoEdicao, setModoEdicao] = useState(false);
  const [modoClonagem, setModoClonagem] = useState(false);
  const [itemEditando, setItemEditando] = useState(null);
  const [form, setForm] = useState(estadoInicial);
  const [modoPrint, setModoPrint] = useState(false);
  const [itemPrint, setItemPrint] = useState(null);
  const [autoPrint, setAutoPrint] = useState(false);
  const [usuarioAtual, setUsuarioAtual] = useState(null);

  useEffect(() => {
    let cancelado = false;

    async function carregarDados() {
      setLoading(true);

      try {
        const usuario = await getUsuarioAtualComTenant();
        if (cancelado) return;

        setUsuarioAtual(usuario);
        await Promise.all([
          carregarCaracterizacoes(usuario),
          carregarMateriais(usuario),
          carregarObras(usuario),
        ]);
      } catch (erro) {
        console.error("Erro ao carregar a caracterização:", erro);
        if (!cancelado) {
          alert("Não foi possível carregar os dados da caracterização. Verifique suas permissões e tente novamente.");
        }
      } finally {
        if (!cancelado) setLoading(false);
      }
    }

    carregarDados();
    return () => {
      cancelado = true;
    };
  }, []);

  useEffect(() => {
    if (cadastroUrlProcessadoRef.current || !materiais.length || !obras.length) return;

    const params = new URLSearchParams(location.search);
    if (params.get("novo") !== "1") return;

    const tipoAgregado = params.get("tipoAgregado") === "miudo" ? "miudo" : "graudo";
    const materialId = params.get("materialId") || "";
    const solicitacaoId = params.get("solicitacaoId") || "";
    const material = materialId ? materiais.find((item) => item.id === materialId) : null;

    if (materialId && !material) return;

    cadastroUrlProcessadoRef.current = true;
    abrirNovoCadastro(tipoAgregado, material, solicitacaoId);
  }, [location.search, materiais, obras]);

  async function carregarCaracterizacoes(usuario = usuarioAtual) {
    const q = query(
      collection(db, "tblCaracterizacaoAgregados"),
      ...tenantWhere(usuario)
    );
    const snap = await getDocs(consultaTenantAtual(q));
    setCaracterizacoes(
      snap.docs
        .map((documento) => ({ id: documento.id, ...documento.data() }))
        .sort(compararCodigosCaracterizacaoDecrescente)
    );
  }

  async function carregarMateriais(usuario = usuarioAtual) {
    const q = query(
      collection(db, "tblListaMateriaisCadastrados"),
      ...tenantWhere(usuario)
    );
    const snap = await getDocs(consultaTenantAtual(q));
    setMateriais(
      snap.docs
        .map((documento) => ({ id: documento.id, ...documento.data() }))
        .sort((a, b) => String(b.codigo || "").localeCompare(String(a.codigo || ""), "pt-BR", { numeric: true }))
    );
  }

  async function carregarObras(usuario = usuarioAtual) {
    const snap = await getDocs(query(collection(db, "obras"), ...tenantWhere(usuario)));
    setObras(snap.docs.map((documento) => ({ id: documento.id, ...documento.data() })));
  }

  function abrirNovoCadastro(tipoAgregado = "graudo", materialSelecionado = null, solicitacaoId = "") {
    const base = tipoAgregado === "miudo" ? estadoInicialMiudo : estadoInicial;
    const granulometriaBase = tipoAgregado === "miudo" ? granulometriaMiudoModelo : granulometriaModelo;
    const obraEncontrada = obras.find((obra) => obra.id === materialSelecionado?.ObraId);

    setModoEdicao(false);
    setModoClonagem(false);
    setItemEditando(null);
    setForm({
      ...base,
      fornecedor: materialSelecionado?.Fornecedor || "",
      solicitacaoId,
      fornecedorId: materialSelecionado?.id || "",
      codigoFornecedor: materialSelecionado?.codigo || "",
      cliente: materialSelecionado?.Cliente || "",
      obra: obraEncontrada?.nome || "",
      obraId: materialSelecionado?.ObraId || "",
      amostra: materialSelecionado?.Descricao || "",
      localColeta: materialSelecionado?.LocalColeta || "",
      procedencia: materialSelecionado?.Fornecedor || "",
      densidade: { ...base.densidade },
      massaUnitaria: { ...base.massaUnitaria },
      torroesPulverulentos: { ...base.torroesPulverulentos },
      granulometria: granulometriaBase.map((linha) => ({ ...linha })),
    });
    setOpenDialog(true);
  }

  function selecionarFornecedor(material) {
    const obraEncontrada = obras.find((obra) => obra.id === material?.ObraId);

    setForm({
      ...form,
      fornecedor: material?.Fornecedor || "",
      fornecedorId: material?.id || "",
      codigoFornecedor: material?.codigo || "",
      cliente: material?.Cliente || "",
      obra: obraEncontrada?.nome || "",
      obraId: material?.ObraId || "",
      amostra: material?.Descricao || "",
      localColeta: material?.LocalColeta || form.localColeta || "",
      procedencia: material?.Fornecedor || form.procedencia || "",
    });
  }

  function selecionarObraClonagem(obra) {
    setForm((formAtual) => ({
      ...formAtual,
      obra: obra?.nome || "",
      obraId: obra?.id || "",
      cliente: obra?.clienteNome || formAtual.cliente || "",
      clienteId: obra?.clienteId || formAtual.clienteId || "",
    }));
  }

  function editarCaracterizacao(item) {
    const isMiudo = ehAgregadoMiudo(item);
    const base = isMiudo ? estadoInicialMiudo : estadoInicial;
    const peneirasBase = isMiudo ? peneirasMiudo : peneirasPadrao;
    const granulometriaBase = isMiudo ? granulometriaMiudoModelo : granulometriaModelo;
    const codigoAtual = separarCodigoCaracterizacao(item.codigo);

    setModoEdicao(true);
    setModoClonagem(false);
    setItemEditando(item);
    setForm({
      ...base,
      ...item,
      codigo: codigoAtual.base,
      complementoCodigo: codigoAtual.complemento,
      densidade: { ...base.densidade, ...(item.densidade || {}) },
      massaUnitaria: { ...base.massaUnitaria, ...(item.massaUnitaria || {}) },
      torroesPulverulentos: {
        ...base.torroesPulverulentos,
        ...(item.torroesPulverulentos || {}),
      },
      granulometria: peneirasBase.map((peneira, index) => ({
        ...granulometriaBase[index],
        ...(item.granulometria?.[index] || {}),
        peneira,
      })),
    });
    setOpenDialog(true);
  }

  function clonarCaracterizacao(item) {
    const isMiudo = ehAgregadoMiudo(item);
    const base = isMiudo ? estadoInicialMiudo : estadoInicial;
    const peneirasBase = isMiudo ? peneirasMiudo : peneirasPadrao;
    const granulometriaBase = isMiudo ? granulometriaMiudoModelo : granulometriaModelo;
    const codigoOriginal = separarCodigoCaracterizacao(item.codigo);
    const dadosClonados = { ...item };

    [
      "id",
      "codigo",
      "complementoCodigo",
      "clonadoDeId",
      "solicitacaoId",
      "dataCadastro",
      "criadoEm",
      "criadoPor",
      "atualizadoEm",
      "atualizadoPor",
    ].forEach((campo) => delete dadosClonados[campo]);

    setModoEdicao(false);
    setModoClonagem(true);
    setItemEditando(null);
    setForm({
      ...base,
      ...dadosClonados,
      codigo: codigoOriginal.base,
      complementoCodigo: "B",
      clonadoDeId: item.clonadoDeId || item.id,
      densidade: { ...base.densidade, ...(item.densidade || {}) },
      massaUnitaria: { ...base.massaUnitaria, ...(item.massaUnitaria || {}) },
      torroesPulverulentos: {
        ...base.torroesPulverulentos,
        ...(item.torroesPulverulentos || {}),
      },
      granulometria: peneirasBase.map((peneira, index) => ({
        ...granulometriaBase[index],
        ...(item.granulometria?.[index] || {}),
        peneira,
      })),
    });
    setOpenDialog(true);
  }

  async function salvarCaracterizacao() {
    if (!form.amostra) {
      alert("Informe a amostra antes de salvar.");
      return;
    }

    if (!modoEdicao) {
      const camposIdenticos = ["fornecedorId", "obraId", "amostra", "tipoAgregado", "localColeta", "procedencia"];
      const cadastroIdentico = caracterizacoes.some((item) =>
        camposIdenticos.every((campo) => normalizarTexto(item[campo]) === normalizarTexto(form[campo]))
      );

      if (cadastroIdentico && !(await confirmarSistema("Já existe uma caracterização idêntica cadastrada. Deseja cadastrar mesmo assim?"))) {
        return;
      }
    }

    const codigoBaseInformado = String(form.codigo || "").trim();
    const complementoCodigo = String(form.complementoCodigo || "").trim().toUpperCase();

    if (codigoBaseInformado && !/^\d+$/.test(codigoBaseInformado)) {
      alert("O código-base deve conter somente números.");
      return;
    }

    if (complementoCodigo && !/^[A-Z0-9]{1,5}$/.test(complementoCodigo)) {
      alert("O complemento deve conter até 5 letras ou números, sem pontos ou espaços.");
      return;
    }

    if (complementoCodigo && !codigoBaseInformado) {
      alert("Informe o código-base para utilizar um complemento.");
      return;
    }

    if (modoEdicao && !codigoBaseInformado) {
      alert("Informe o código-base da caracterização.");
      return;
    }

    const codigoBase = codigoBaseInformado || (await gerarSequencial({
      chave: "caracterizacao_agregados",
      formato: { padding: 3 },
      valorMinimo: obterMaiorSequencial(caracterizacoes),
    })).codigo;
    const codigo = montarCodigoCaracterizacao(codigoBase, complementoCodigo);

    const codigoDuplicado = caracterizacoes.some(
      (item) =>
        item.id !== itemEditando?.id &&
        String(item.codigo || "").toUpperCase() === codigo.toUpperCase()
    );

    if (codigoDuplicado) {
      alert(`O código ${codigo} já está sendo utilizado.`);
      return;
    }

    const usuario = usuarioAtual || await getUsuarioAtualComTenant();
    if (!usuario.tenantId) {
      alert("Usuário sem empresa vinculada. Entre com um administrador de cliente SaaS para cadastrar a caracterização.");
      return;
    }

    const formSemComplemento = { ...form };
    delete formSemComplemento.complementoCodigo;

    const dados = aplicarTenant({
      ...formSemComplemento,
      codigo,
      tipoAgregado: form.tipoAgregado || "graudo",
      status: modoEdicao ? (form.status || "ativo") : "ativo",
      atualizadoEm: new Date(),
    }, usuario);

    let caracterizacaoId = itemEditando?.id || "";

    try {
      if (modoEdicao && itemEditando?.id) {
        await atualizarDocumentoComMesclagem({
          db,
          referencia: doc(db, "tblCaracterizacaoAgregados", itemEditando.id),
          original: itemEditando,
          atual: { ...itemEditando, ...dados },
          metadados: { atualizadoEm: dados.atualizadoEm },
        });
      } else {
        const hoje = new Date().toISOString().slice(0, 10);
        if (dados.solicitacaoId) {
          const ref = await addDoc(collection(db, "tblCaracterizacaoAgregados"), aplicarTenantAtual({
            ...dados,
            dataCadastro: hoje,
            criadoEm: new Date(),
          }));
          caracterizacaoId = ref.id;
        } else {
          const solicitacoesSnap = await getDocs(
            query(
              collection(db, "tblSolicitacoesServicos"),
              ...tenantWhere(usuario)
            )
          );
          const maiorNumeroOS = solicitacoesSnap.docs.reduce((maior, documento) => {
            const solicitacao = documento.data();
            const numero = Number(
              solicitacao.numeroOS ||
              solicitacao.numeroOs ||
              solicitacao.numero ||
              0
            );
            return Number.isFinite(numero) && numero > maior ? numero : maior;
          }, 0);
          const sequencialOS = await gerarSequencial({
            chave: "os_interna",
            formato: { padding: 4 },
            valorMinimo: maiorNumeroOS,
          });
          const numeroOS = sequencialOS.numero;
          const materialSelecionado =
            materiais.find((material) => material.id === form.fornecedorId) || {};
          const usuarioResumo = {
            uid: usuario.uid,
            nome: usuario.nome,
            email: usuario.email,
            tipo: usuario.tipo,
          };
          const solicitacaoRef = doc(collection(db, "tblSolicitacoesServicos"));
          const caracterizacaoRef = doc(collection(db, "tblCaracterizacaoAgregados"));
          const batch = writeBatch(db);

          batch.set(
            solicitacaoRef,
            aplicarTenant({
              numeroOS,
              numeroOSFormatado: String(numeroOS || 0).padStart(4, "0"),
              data: hoje,
              clienteId: form.clienteId || "",
              cliente: form.cliente || "",
              obraId: form.obraId || "",
              obra: form.obra || "",
              materialId: form.fornecedorId || "",
              material: Object.keys(materialSelecionado).length
                ? labelMaterial(materialSelecionado)
                : form.amostra || "",
              materialDados: materialSelecionado,
              ensaios: ENSAIOS_CARACTERIZACAO.map((ensaio) => ({
                id: ensaio.id,
                nome: ensaio.nome,
                rota: ensaio.rota || "",
                categoria: ensaio.categoria || "",
                status: "pendente",
              })),
              observacoes: `O.S. gerada automaticamente pelo cadastro da caracterização ${codigo}.`,
              atualizadoEm: new Date(),
              atualizadoPor: usuarioResumo,
              criadoEm: new Date(),
              criadoPor: usuarioResumo,
            }, usuario)
          );

          batch.set(
            caracterizacaoRef,
            aplicarTenant({
              ...dados,
              solicitacaoId: solicitacaoRef.id,
              dataCadastro: hoje,
              criadoEm: new Date(),
            }, usuario)
          );

          await batch.commit();
          caracterizacaoId = caracterizacaoRef.id;
        }
      }
    } catch (erro) {
      console.error("Erro ao salvar a caracterização:", erro);
      alert("Não foi possível salvar a caracterização. Verifique suas permissões e tente novamente.");
      return;
    }

    setOpenDialog(false);
    if (caracterizacaoId) {
      history.push(rotaDetalhesCaracterizacao(dados, caracterizacaoId));
      return;
    }
    await carregarCaracterizacoes();
  }

  function abrirRelatorio(item, imprimir = false) {
    if (!imprimir) {
      history.replace({
        pathname: location.pathname,
        search: location.search,
        hash: location.hash,
        state: {
          ...(location.state || {}),
          filtroCaracterizacao: filtro,
          filtroStatusCaracterizacao: filtroStatus,
        },
      });

      history.push("/app/relatorios/caracterizacao", {
        materialId: item.id,
        abrirPrevia: true,
        origemListaCaracterizacao: true,
      });
      return;
    }

    const material = materiais.find((materialItem) => materialItem.id === item.fornecedorId);
    setItemPrint({
      ...item,
      tipoAgregado: ehAgregadoMiudo(item) ? "miudo" : "graudo",
      codigoFornecedor: item.codigoFornecedor || material?.codigo || "",
    });
    setAutoPrint(imprimir);
    setModoPrint(true);
  }

  function abrirDetalhes(item) {
    history.replace({
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      state: {
        ...(location.state || {}),
        filtroCaracterizacao: filtro,
        filtroStatusCaracterizacao: filtroStatus,
      },
    });

    history.push(
      ehAgregadoMiudo(item)
        ? `/app/cadastro-caracterizacao-miudo/${item.id}`
        : `/app/cadastro-caracterizacao/${item.id}`
    );
  }

  async function alternarStatusCaracterizacao(item) {
    const estaCancelado = item.status === "cancelado";
    const novoStatus = estaCancelado ? "ativo" : "cancelado";
    const mensagem = estaCancelado
      ? `Deseja reativar a caracterização ${item.codigo || "selecionada"}?`
      : `Deseja cancelar a caracterização ${item.codigo || "selecionada"}?`;

    if (!(await confirmarSistema(mensagem))) return;

    setItemAtualizandoStatusId(item.id);

    try {
      const atualizadoEm = new Date();

      await atualizarDocumentoComMesclagem({
        db,
        referencia: doc(db, "tblCaracterizacaoAgregados", item.id),
        original: item,
        atual: { ...item, status: novoStatus, atualizadoEm },
        metadados: { atualizadoEm },
      });

      setCaracterizacoes((listaAtual) =>
        listaAtual.map((registro) =>
          registro.id === item.id
            ? { ...registro, status: novoStatus, atualizadoEm }
            : registro
        )
      );
    } catch (error) {
      console.error("Erro ao alterar status da caracterização:", error);
      alert("Não foi possível alterar o status da caracterização.");
    } finally {
      setItemAtualizandoStatusId("");
    }
  }

  const listaFiltrada = useMemo(() => {
    const termo = normalizarTexto(filtro);
    return caracterizacoes.filter((item) => {
      const dataCadastro =
        item.dataCadastro ||
        item.criadoEm?.toDate?.()?.toISOString?.()?.slice(0, 10) ||
        "";
      const codigoMaterial =
        item.codigoFornecedor ||
        materiais.find((material) => material.id === item.fornecedorId)?.codigo ||
        "";
      const estaCancelado = item.status === "cancelado";
      const correspondeStatus =
        filtroStatus === "todos" ||
        (filtroStatus === "ativos" && !estaCancelado) ||
        (filtroStatus === "cancelados" && estaCancelado);
      const correspondePesquisa =
        !termo ||
        [
          item.codigo,
          item.cliente,
          item.obra,
          codigoMaterial,
          item.amostra,
          item.procedencia,
          item.localColeta,
          dataCadastro,
          formatarDataBR(dataCadastro),
          item.operadorGranulometria,
        ].some((valor) =>
          normalizarTexto(valor).includes(termo)
        );

      return correspondeStatus && correspondePesquisa;
    });
  }, [caracterizacoes, filtro, filtroStatus, materiais]);

if (modoPrint && itemPrint) {
  const ComponenteRelatorio =
    ehAgregadoMiudo(itemPrint) ? RelatorioCaracterizacaoMiudoPrint : RelatorioCaracterizacaoPrint;

  return (
    <ComponenteRelatorio
      caracterizacao={itemPrint}
      autoPrint={autoPrint}
      onVoltar={() => {
          setModoPrint(false);
          setAutoPrint(false);
          setItemPrint(null);
        }}
      />
    );
  }

  return (
    <>
      <Navbar />

      <Box sx={{ p: { xs: 2, md: 4 } }}>
        <Paper className="cabecalho-lista-cadastro" elevation={0}>
        <Typography variant="h6" fontWeight={700}>Caracterização de Agregados</Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>Cadastro e impressão dos ensaios de caracterização</Typography>
        <Stack direction={{ xs: "column", md: "row" }} alignItems="stretch" spacing={2} mb={3}>
          <Button
            variant="contained"
            onClick={() => history.push("/app/solicitacao-servicos", { origemCaracterizacao: true })}
          >
            Cadastrar
          </Button>
          <Button variant="outlined" onClick={() => history.push("/app/relatorios/caracterizacao")}>
            Relatório Caracterização
          </Button>
          <TextField
            size="small"
            label="Pesquisar"
            placeholder="Código, amostra, local, procedência ou operador"
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
            sx={{ flex: 1 }}
          />
          <TextField
            select
            size="small"
            label="Status"
            value={filtroStatus}
            onChange={(event) => setFiltroStatus(event.target.value)}
            sx={{ minWidth: 150 }}
          >
            <MenuItem value="todos">Mostrar todos</MenuItem>
            <MenuItem value="ativos">Todos ativos</MenuItem>
            <MenuItem value="cancelados">Cancelados</MenuItem>
          </TextField>
          <TextField size="small" label="Qtd" value={listaFiltrada.length} InputProps={{ readOnly: true }} sx={{ width: 110 }} />
        </Stack>
        </Paper>

        <Paper sx={{ borderRadius: "8px", overflow: "auto", border: "1px solid #e2e8f0", boxShadow: "none" }}>
          <Table className="lista-cadastro-padrao" size="small" sx={{ minWidth: 900 }}>
            <TableHead
              sx={{
                backgroundColor: "#f8fafc",
                "& .MuiTableCell-head": {
                  backgroundColor: "#f8fafc",
                  color: "#0d47a1",
                  fontWeight: 700,
                  verticalAlign: "middle",
                  borderLeft: "none",
                  borderRight: "none",
                  borderBottom: "1px solid #cbd5e1",
                  whiteSpace: "nowrap",
                },
              }}
            >
              <TableRow>
                <TableCell><strong>Cod</strong></TableCell>
                <TableCell>Cliente / Obra</TableCell>
                <TableCell>Amostra / Procedencia</TableCell>
                <TableCell sx={{ width: 110, maxWidth: 110 }}>Local da coleta</TableCell>
                <TableCell>Data</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="center">Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {listaFiltrada.map((item) => (
                <TableRow
                  key={item.id}
                  hover
                  sx={{
                    cursor: "pointer",
                    backgroundColor: item.status === "cancelado" ? "#fff5f5" : "inherit",
                    opacity: item.status === "cancelado" ? 0.8 : 1,
                  }}
                  onClick={() => abrirDetalhes(item)}
                >
                  <TableCell>{item.codigo || "-"}</TableCell>
                  <TableCell>
                    {item.cliente || item.obra ? (
                      <Stack spacing={0.25}>
                        <Typography component="span" variant="body2" sx={{ color: "#0f2f5f", fontWeight: 700 }}>
                          {item.cliente || "-"}
                        </Typography>
                        <Typography component="span" variant="caption" sx={{ color: "#475569", fontWeight: 600 }}>
                          {item.obra || "-"}
                        </Typography>
                      </Stack>
                    ) : (
                      "-"
                    )}
                  </TableCell>
                  <TableCell>
                    {item.amostra || item.procedencia ? (
                      <Stack spacing={0.25}>
                        <Typography component="span" variant="body2" sx={{ color: "#14532d", fontWeight: 700 }}>
                          {(() => {
                            const codigoMaterial =
                              item.codigoFornecedor ||
                              materiais.find((material) => material.id === item.fornecedorId)?.codigo ||
                              "";
                            return `${codigoMaterial ? `COD.${codigoMaterial} - ` : ""}${item.amostra || "-"}`;
                          })()}
                        </Typography>
                        <Typography component="span" variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>
                          {item.procedencia || "-"}
                        </Typography>
                      </Stack>
                    ) : (
                      "-"
                    )}
                  </TableCell>
                  <TableCell sx={{ width: 110, maxWidth: 110 }}>
                    <Typography
                      component="span"
                      variant="caption"
                      sx={{ color: "#64748b", fontWeight: 600, overflowWrap: "anywhere" }}
                    >
                      {item.localColeta || "-"}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography component="span" variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>
                      {formatarDataBR(
                        item.dataCadastro ||
                        item.criadoEm?.toDate?.()?.toISOString?.()?.slice(0, 10)
                      )}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      component="span"
                      variant="caption"
                      sx={{
                        color: item.status === "cancelado" ? "#c62828" : "#2e7d32",
                        fontWeight: 700,
                      }}
                    >
                      {item.status === "cancelado" ? "Cancelado" : "Ativo"}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Tooltip title="Visualizar relatório">
                      <IconButton
                        size="small"
                        onClick={(event) => {
                          event.stopPropagation();
                          abrirRelatorio(item, false);
                        }}
                      >
                        <VisibilityIcon sx={{ color: "primary.main" }} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Editar cadastro">
                      <IconButton
                        size="small"
                        onClick={(event) => {
                          event.stopPropagation();
                          editarCaracterizacao(item);
                        }}
                      >
                        <EditIcon sx={{ color: "#0288d1" }} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Clonar caracterização">
                      <IconButton
                        size="small"
                        onClick={(event) => {
                          event.stopPropagation();
                          clonarCaracterizacao(item);
                        }}
                      >
                        <ContentCopyIcon sx={{ color: "#7b1fa2" }} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={item.status === "cancelado" ? "Reativar" : "Cancelar"}>
                      <span>
                        <IconButton
                          data-confirmacao-cancelamento="propria"
                          size="small"
                          disabled={itemAtualizandoStatusId === item.id}
                          onClick={(event) => {
                            event.stopPropagation();
                            alternarStatusCaracterizacao(item);
                          }}
                        >
                          {item.status === "cancelado" ? (
                            <RestoreIcon sx={{ color: "#2e7d32" }} />
                          ) : (
                            <CloseIcon sx={{ color: "#d32f2f" }} />
                          )}
                        </IconButton>
                      </span>
                    </Tooltip>
                    <HistoricoCadastro colecao="tblCaracterizacaoAgregados" documentoId={item.id} registro={item} />
                  </TableCell>
                </TableRow>
              ))}

              {loading && <TableRow><TableCell colSpan={7}><Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 1.5, py: 4 }}><CircularProgress /><Typography color="text.secondary">Carregando registros...</Typography></Box></TableCell></TableRow>}
              {!loading && listaFiltrada.length === 0 && (
                <TableRow>
                  <TableCell colSpan={7} align="center">Nenhuma caracterização cadastrada.</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Paper>
      </Box>

      <Dialog open={openDialog} onClose={() => !salvandoCadastro && setOpenDialog(false)} fullWidth maxWidth="md">
        <DialogTitle>
          {modoEdicao ? "Editar Caracterização" : modoClonagem ? "Clonar Caracterização" : "Nova Caracterização"}
        </DialogTitle>
        <DialogContent dividers>
          <Stack spacing={3} mt={1}>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
              <TextField
                label="Código-base da caracterização"
                value={form.codigo}
                onChange={(event) =>
                  setForm({
                    ...form,
                    codigo: event.target.value.replace(/\D/g, ""),
                  })
                }
                placeholder="Automático"
                helperText="Deixe vazio para gerar automaticamente ou informe somente o número-base."
                inputProps={{ inputMode: "numeric" }}
                fullWidth
              />
              <TextField
                label="Complemento do código (opcional)"
                value={form.complementoCodigo || ""}
                onChange={(event) =>
                  setForm({
                    ...form,
                    complementoCodigo: event.target.value
                      .toUpperCase()
                      .replace(/[^A-Z0-9]/g, "")
                      .slice(0, 5),
                  })
                }
                placeholder="Ex.: B"
                helperText={
                  form.codigo && form.complementoCodigo
                    ? `Código final: ${montarCodigoCaracterizacao(form.codigo, form.complementoCodigo)}`
                    : "Use letras ou números, sem digitar o ponto."
                }
                inputProps={{ maxLength: 5 }}
                fullWidth
              />
            </Stack>

            <TextField
              label="Cliente"
              value={form.cliente}
              InputProps={{ readOnly: true }}
              fullWidth
            />

            {modoClonagem ? (
              <Autocomplete
                options={obras}
                getOptionLabel={(option) => option?.nome || ""}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                value={obras.find((obra) => obra.id === form.obraId) || null}
                onChange={(event, value) => selecionarObraClonagem(value)}
                renderInput={(params) => <TextField {...params} label="Obra" />}
              />
            ) : (
              <TextField
                label="Obra"
                value={form.obra}
                InputProps={{ readOnly: true }}
                fullWidth
              />
            )}

            <Autocomplete
              options={materiais}
              getOptionLabel={(option) =>
                option
                  ? `${option.codigo || ""} - ${option.Cliente || ""} - ${option.Fornecedor || ""} - ${tipoMaterial(option) || option.Descricao || ""}`
                  : ""
              }
              isOptionEqualToValue={(option, value) => option.id === value.id}
              value={materiais.find((material) => material.id === form.fornecedorId) || null}
              onChange={(event, value) => selecionarFornecedor(value)}
              renderInput={(params) => <TextField {...params} label="Fornecedor" />}
            />

            <TextField
              label="Agregado"
              value={form.amostra}
              InputProps={{ readOnly: true }}
              fullWidth
            />

            <TextField
              label="Local da coleta"
              value={form.localColeta}
              onChange={(e) => setForm({ ...form, localColeta: e.target.value })}
              fullWidth
            />

            <TextField
              label="Procedência"
              value={form.procedencia}
              onChange={(e) => setForm({ ...form, procedencia: e.target.value })}
              fullWidth
            />

          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} disabled={salvandoCadastro}>Cancelar</Button>
          <Button variant="contained" onClick={() => executarSalvamento(salvarCaracterizacao)} disabled={salvandoCadastro}>
            {salvandoCadastro ? "Salvando..." : modoClonagem ? "Salvar clone e abrir" : "Salvar e abrir"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
